export enum AuditAction {
  CREATE = 'create',
  READ = 'read',
  UPDATE = 'update',
  DELETE = 'delete',
  LOGIN = 'login',
  LOGOUT = 'logout',
  APPROVE = 'approve',
  REJECT = 'reject',
  SEARCH = 'search',
}

export interface AuditLog {
  id: string;
  userId: string;
  user: {
    id: string;
    email: string;
    role: string;
  };
  action: AuditAction;
  entityType?: string;
  entityId?: string;
  details?: any;
  ipAddress?: string;
  userAgent?: string;
  createdAt: string;
}

export interface AuditLogQuery {
  userId?: string;
  action?: AuditAction;
  entityType?: string;
  entityId?: string;
  startDate?: string;
  endDate?: string;
  page?: number;
  limit?: number;
}

export interface AuditLogResponse {
  logs: AuditLog[];
  pagination: {
    total: number;
    page: number;
    limit: number;
    totalPages: number;
  };
}

export interface EntityAuditTrailResponse {
  entityType: string;
  entityId: string;
  auditTrail: AuditLog[];
}

export interface UserActivityResponse {
  userId: string;
  days: number;
  activity: AuditLog[];
}

export interface ActivityStats {
  totalActions: number;
  actionsByType: Record<AuditAction, number>;
  activeUsers: number;
  topUsers: Array<{
    userId: string;
    userEmail: string;
    actionCount: number;
  }>;
}

export interface ActivityStatsResponse {
  days: number;
  stats: ActivityStats;
}